module.exports = __webpack_public_path__ + "necklace.jpg?47522844e867a51343e6ed8b2c17eee0";